import { MadSDKAPIError } from "../../../../../errors/base";
export class RejectionReasonsFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RejectionReasonsFetchFailed);
        }
        this.name = "RejectionReasonsFetchFailed";
        this.message = "Failed to fetch rejection reasons data. Please try again at a later time.";
    }
}
//# sourceMappingURL=errors.js.map